import React, { useEffect } from 'react';
import LoadingSpinner from './LoadingSpinner';
import quoteMachineLogo from '../assets/QuoteMachine.png';

const LoginPage = () => {
  useEffect(() => {
    const initializeLogin = () => {
      if (window.catalyst && window.catalyst.auth) {
        window.catalyst.auth.signIn("catalyst-login");
      } else {
        setTimeout(initializeLogin, 100);
      }
    };
    initializeLogin();
  }, []);

  return (
    <div style={{
        // --- ZMĚNY VE STYLU HLAVNÍHO KONTEJNERU ---
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh', 
        backgroundColor: '#6b7f8f', // Nová barva pozadí
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", // Sjednocení písma
    }}>
      
      <img src={quoteMachineLogo} alt="QuoteMachine Logo" style={{ height: '70px', marginBottom: '20px' }} />
      
      <h2 style={{ 
          color: '#ffffff', // Bílá barva pro lepší kontrast
          fontWeight: 300, // Lehčí řez písma
          fontSize: '2em',
          marginBottom: '30px'
      }}>
        Sign In
      </h2>
      
      <div 
        id="catalyst-login" 
        style={{
          width: '380px',  // Lehce širší
          height: '600px', // Větší výška pro odstranění scrollbaru
          border: 'none', // Odstranění rámečku, spolehneme se na stín
          borderRadius: '8px',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)', // Výraznější stín
          overflow: 'hidden',
          backgroundColor: 'white'
        }}
      >
        <LoadingSpinner text="Loading Sign In form..." />
      </div>
    </div>
  );
};

export default LoginPage;